import { GlobalState } from "@/Reducers/interface";
import { BillingStatusEnum } from "@/Contracts/Users";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useAccountStatus = (billingStatus: BillingStatusEnum) => {
	const billingInfo = useSelector(
		(state: GlobalState) => state.user.billingInfo
	);

	const [blockAccount, setBlockAccount] = useState<boolean>(false);

	useEffect(() => {
		const blockedStatus = billingInfo.billing_status === billingStatus;
		setBlockAccount(blockedStatus);
	}, [billingInfo]);

	return blockAccount;
};

export default useAccountStatus;
